import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
//mui
import {Box, IconButton, Typography} from '@mui/material';
//icons
import {ReactComponent as ArrowRightIcon} from '@icons/arrow-right.svg';
//types
import {IEventTodoList, IOrganizationEvent} from '@/utils/types';
//components
import Checkbox from '@components/Checkbox';
//constants
import {SUBTITLE1, SUBTITLE2} from '@constants/index';
//styles
import {todoItemStyle} from './TodoItem.styles';
import {getErrorMessage} from '@/utils/helpers';
import {OrganizationEventService} from '@/utils/services';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector, getEventTodoList} from '@/store/organization-event';

const todoLinkList: {[key: string]: string} = {
	ReviewEventSettings: '/organization/event-settings',
	AddSponsorTiers: '/organization/event-settings',
	TableTicketSettings: '/organization/tables',
	AddAuctionItems: '/organization/auction',
	CustomizeEmailTemplates: '/organization/communications/customization',
	CustomizeTicketPage: '/organization/tables',
	ReviewInvoiceEmail: '/organization/communications/invoice-email',
	ReviewAcknowledgmentEmail: '/organization/communications/payment-acknowledgement',
	TableUpdateEmail: '/organization/communications/table-update-email',
	PatronUpdateEmail: '/organization/communications/patron-update-email',
	AuctionEmail: '/organization/communications/auction-email',
	InvoiceEmail: '/organization/communications/invoice-email',
	NotifyAuctionStart: '/organization/profile/notifications',
	PrintBidSheets: '/organization/printables/bid-sheets',
};

const TodoItem: FC<{todoItem: IEventTodoList}> = ({todoItem}) => {
	const currentEvent: IOrganizationEvent | null = useAppSelector(getCurrentEventSelector);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const handleNavigateClick = () => {
		navigate(`${todoLinkList[todoItem.templateKey]}`);
	};

	const handleTodoItemCheck = async () => {
		if (!todoItem.id) return;
		try {
			await OrganizationEventService.updateTodoItem({
				id: +todoItem.id,
				isDone: !todoItem.isDone,
			});

			await dispatch(
				getEventTodoList({
					id: currentEvent!.id,
					isDone: false,
				})
			).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	return (
		<Box sx={todoItemStyle.wrapper}>
			{todoItem.id && <Checkbox value={todoItem.isDone} onChange={handleTodoItemCheck} />}

			<Box sx={todoItemStyle.content}>
				<Typography variant={SUBTITLE1}>{todoItem.name}</Typography>

				<Typography sx={todoItemStyle.description} variant={SUBTITLE2}>
					{todoItem.description}
				</Typography>
			</Box>

			<IconButton sx={todoItemStyle.navigateIcon} disableRipple onClick={handleNavigateClick}>
				<ArrowRightIcon />
			</IconButton>
		</Box>
	);
};

export default TodoItem;
